import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { EmailMasterService } from 'src/app/core/services/emailMaster/email-master.service';
import { BehaviorSubject, lastValueFrom, Subject, takeUntil } from 'rxjs';
import { MatSelectChange } from '@angular/material/select';
import { UniversityCommunicationService } from 'src/app/core/services/university-communication/university-communication.service';
import { OptionsService } from 'src/app/core/services/options/options.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { maxAttachmentSize } from 'src/app/core/constants/mail-box-const';
import { BankMailDetailsService } from 'src/app/core/services/bank-mail-details/bank-mail-details.service';

@Component({
  selector: 'app-compose-mail',
  templateUrl: './compose-mail.component.html',
  styleUrls: ['./compose-mail.component.scss']
})
export class ComposeMailComponent implements OnInit, OnDestroy {
  editor: Editor;
  toolbar: Toolbar = [
    // default value
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ['horizontal_rule', 'format_clear'],
  ];
  SelectAll: boolean = false;
  showBankDropdown: boolean = false;
  selectedBank: any;
  bankNameControl = new FormControl(); 
  bankNameFilterCtrl: FormControl = new FormControl();
  filteredBankList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  toUsername = new FormControl('');
  toDomain: string = ''; 
  private originalBankList: any[] = [];
  routerUrl = urlRoutes;
  email_form: FormGroup;
  to_email_list: string[] = [];
  user_details: any;
  is_submitted: boolean = false;
  email_subject_list: any;
  email_all_subject_list: any;
  email_template_list: any;
  selectedFile: File | null = null;
  upload_files: any[] = [];
  @Input() application_details: any;
  @Input() cams_id: any;
  subject_msg: string;
  from_mail_list: any;
  private _unsubscribeAll: Subject<any> = new Subject();
  cc_email_list: string[] = [];
  bcc_email_list: string[] = [];
  maxAttachmentSize: number = maxAttachmentSize;
  zonalOfficeList: any[] = [];
  selectedZonalOffice: string | null = null;
  NoZonalOffice:boolean = false;

  constructor(
    private _authenticationService: AuthenticationService,
    private _fb: FormBuilder,
    private _emailMasterService: EmailMasterService,
    private _loaderService: LoaderService,
    private _toasterService: ToasterService,
    private _universitycommunicationService: UniversityCommunicationService,
    private _optionService: OptionsService,
    public dialogRef: MatDialogRef<ComposeMailComponent>,
    private bankMailDetailsService: BankMailDetailsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    console.log(this.data,'')
    this.editor = new Editor();
    this.user_details = this._authenticationService.getLoginUserDetails();
    this.initiateEmailForm();
    this.bankNameFilterCtrl.valueChanges
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(() => {
      this.filterBankList();
    });
    this.application_details = this.data?.application_details;
    this.cams_id = this.data?.cams_id;
    if (this.application_details) {
      this.getCourseType();
      // this.getEmailEvents();
    }
  }



  initiateEmailForm() {
    this.email_form = this._fb.group({
      from: ['', [Validators.required, Validators.email]],
      to: ['', [Validators.required]],
      cc: [''],
      bcc: [''],
      subject: ['', [Validators.required]],
      html: ['', [Validators.required]],
      attachments: [[]],
      agentStatus: [false],
    })
  }

  async getCourseType() {
    this._loaderService.showLoader();
    try {
      const res = await this._optionService.getOptionsForCourseType()
        .pipe(takeUntil(this._unsubscribeAll))
        .toPromise();

      if (res && res?.data) {
        let option = res?.data?.data[0];
        if (option) {
          let find_course_type = option?.options?.find(
            (element: any) => element?.name?.toLowerCase() === this.application_details?.courseLevel?.toLowerCase()
          );

          if (find_course_type) {
            await this.getAllEmailEvents(find_course_type.id); // Ensure await is used
            this.getEmailEvents(find_course_type.id);
          }
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      this._loaderService.hideLoader();
    }
  }


  getEmailEvents(courseTypeId, tempCountryId?: string) {
    let params = {
      c_id: this.application_details?.student_details?.countryId,
      u_id: this.application_details?.university?.id,
      uni_c_Id: this.application_details?.university?.universityCountry,
      course_id: courseTypeId
    }
    this._loaderService.showLoader();
    this._emailMasterService.getEmailSubject(params)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(result => {
        if (result) {
          const events = result?.data?.data;
          const allEvents = [...this.email_all_subject_list, ...events];
          this.email_subject_list = Array.from(
            new Map(allEvents.map(event => [event?.emailTemplate?.id, event])).values()
          );
          this.email_subject_list = this.email_subject_list.sort((a, b) => {
            return a.emailTemplate?.name.localeCompare(b.emailTemplate?.name);
          });
          this._loaderService.hideLoader();
        }
      }, (err) => {
        this._loaderService.hideLoader();
      })
  }

  async getAllEmailEvents(courseTypeId, tempCountryId: string = '99') {
    let params = {
      c_id: tempCountryId,
      u_id: this.application_details?.university?.id,
      uni_c_Id: this.application_details?.university?.universityCountry,
      course_id: courseTypeId
    }
    this._loaderService.showLoader();
    const result = await lastValueFrom(this._emailMasterService.getEmailSubject(params)
      .pipe(takeUntil(this._unsubscribeAll)))
    if (result) {
      this.email_all_subject_list = result?.data?.data;
      this._loaderService.hideLoader();
    }
    // this._emailMasterService.getEmailSubject(params)
    //   .pipe(takeUntil(this._unsubscribeAll))
    //   .subscribe(result => {
    //   if (result) {
    //     this.email_subject_list = result?.data?.data;
    //     this._loaderService.hideLoader();
    //   }
    // }, (err) => {
    //   this._loaderService.hideLoader();
    // })
  }

  templateChange(template: MatSelectChange) {
    let find_details = this.email_subject_list.find(element => element?.emailTemplate?.id === template);
    if (find_details) {
      this.subject_msg = find_details?.message?.replaceAll(/&amp;/g, "&").replaceAll(/&lt;/g, "<").replaceAll(/&gt;/g, ">").replaceAll('&nbsp;', ' ');
      this.from_mail_list = find_details?.from;
  
      if (find_details?.to) {
        let to_mail = find_details?.to?.split(',');
        this.to_email_list = to_mail;
      } else {
        this.to_email_list = [];
      }
      this.showBankDropdown = [15, 16, 17].includes(Number(find_details.emailTemplate?.id));
      if (this.showBankDropdown) {
        this.loadBankDetails();
      } 
      // else {
      //   this.clearBankSelection();
      // }
    } else {
      this.clearBankSelection();
    }
  
    this.getEmailTemplate(template);
  }
  loadBankDetails(): void {
    this.bankMailDetailsService.getBankDetailsInMail(this.data?.application_details?.student_details?.countryId)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
        (response: any) => {
          if (response && response.data.data && Array.isArray(response.data.data)) {
            this.originalBankList = response.data.data;
            this.filteredBankList.next(response.data.data); 
          } else {
            this.filteredBankList.next([]);
            this.originalBankList = [];
          }
        },
        (error) => {
          this.filteredBankList.next([]);
        }
      );
  }

  filterBankList(): void {
    if (!this.filteredBankList.value) return;

    let search = this.bankNameFilterCtrl.value;
    if (!search) {
      this.filteredBankList.next(this.originalBankList); 
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredBankList.next(
      this.filteredBankList.value.filter(bank => bank.bankName.toLowerCase().indexOf(search) > -1)
    );
  }
  onBankNameChange(event: MatSelectChange): void {
    const selectedBank = event.value;

    if (selectedBank) {
        this.getZonalOffices(selectedBank.bankName);
    }
}

onZonalOfficeChange(event: MatSelectChange): void {
  const selectedZonalOffice = event.value;
  if (selectedZonalOffice) {
      this.getBankOtherDetails(this.bankNameControl.value.bankName, selectedZonalOffice);
  }
}
getBankOtherDetails(bankName: string, zonalOffice: string): void {
  this.bankMailDetailsService.getBankOtherDetails(bankName, zonalOffice)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
          (response: any) => {
              if (response && response.data) {
                  const bankDetails = response.data;
                  this.to_email_list = [];
                  if (bankDetails.hoEmailId) {
                      const hoEmailIds = bankDetails.hoEmailId.split(',').map(email => email.trim());
                      this.to_email_list.push(...hoEmailIds);
                  }
                  if (bankDetails.domainName) {
                      this.toDomain = `@${bankDetails.domainName}`;
                      this.toUsername.reset(); 
                      this.email_form.get('to').setValue(''); 
                  } else {
                      this.toDomain = '';
                      this.email_form.get('to').setValue('');
                  }
                

              } else {
                  this.toDomain = ''; 
                  this.toUsername.reset(); 
                  this.email_form.get('to').setValue('');
                  this.email_form.get('cc').setValue('');
                  this.cc_email_list = [];
                  this.to_email_list = [];
              }
          },
          (error) => {
              this.toDomain = '';
              this.toUsername.reset();
              this.email_form.get('to').setValue('');
              this.email_form.get('cc').setValue('');
              this.cc_email_list = [];
              this.to_email_list = [];
          }
      );
}

getZonalOffices(bankName: string): void {
  this.bankMailDetailsService.getZonalOffices(bankName)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
          (response: any) => {
              if (response && response.data && Array.isArray(response.data)) {
                  if (response.data.length === 0 || response.data[0] === null) {
                      this.zonalOfficeList = [];
                      this.selectedZonalOffice = 'All';
                      this.NoZonalOffice = true;
                      this.getBankOtherDetails(bankName, 'All');
                  } else {
                      this.zonalOfficeList = response.data;
                      this.selectedZonalOffice = null; 
                  }
              } else {
                  this.zonalOfficeList = [];
                  this.selectedZonalOffice = 'All';
                  this.getBankOtherDetails(bankName, 'All');
              }
          },
          (error) => {
              this.zonalOfficeList = [];
              this.selectedZonalOffice = '';
              this.getBankOtherDetails(bankName, '');
          }
      );
}
  clearBankSelection(): void {
    this.bankNameControl.setValue(null);
    this.toDomain = '';
    this.toUsername.reset();
    this.email_form.get('cc').setValue('');
    this.email_form.get('to').setValue('');
    this.cc_email_list = [];
    this.to_email_list=[];
    this.zonalOfficeList = [];
  }
  getEmailTemplate(temp_id: any) {
    let params = {
      temp_id: temp_id,
      app_id: this.cams_id,
      user_id: this.user_details?.id,
    }
    this._loaderService.showLoader();
    this._emailMasterService.getEmailtemplateByTempId(params)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(result => {
        if (result) {
          this.email_template_list = result?.data;
          this.email_template_list.subject = this.email_template_list?.subject.replaceAll(/&amp;/g, "&")
          this.email_form.get('subject').setValue(this.email_template_list?.subject);
          this.email_form.get('html').setValue(result?.data?.html);
          this._loaderService.hideLoader();
        }
      }, (err) => {
        this._loaderService.hideLoader();
      })
  }

  // addToEmail(event) {
  //   if (this.email_form.get('to').invalid) {
  //     return;
  //   }
  //   let to_email = this.email_form.value.to;
  //   this.to_email_list.push(to_email);
  //   this.email_form.get('to').reset();
  // }
  addToEmail(event) {
    if (event) {
      event.preventDefault();
    }
    if(this.showBankDropdown) {
      const username = this.toUsername.value?.trim();
      if (username && this.toDomain) {
        this.to_email_list.push(username + this.toDomain); 
        this.toUsername.reset(); 
      }
      else if(username){
        this.to_email_list.push(username);
        this.toUsername.reset();
      }
      else {
        if (!username) {
          this.toUsername.markAsTouched();
        }
      }
      this.email_form.get('to').reset();
    }
    else{
      if (this.email_form.get('to').invalid) {
        return;
      }
      let to_email = this.email_form.value.to;
      if (to_email) {
         this.to_email_list.push(to_email);
         this.email_form.get('to').reset();
      }
    }
  }

  removeToEmail(index) {
    this.to_email_list.splice(index, 1);
  }

  addCCEmail(event) {
    if (this.email_form.get('cc').invalid) {
      return;
    }
    let cc_email = this.email_form.value.cc;
    this.cc_email_list.push(cc_email);
    this.email_form.get('cc').reset();
  }

  removeCCEmail(index) {
    this.cc_email_list.splice(index, 1);
  }

  addBCCEmail(event) {
    if (this.email_form.get('bcc').invalid) {
      return;
    }
    let bcc_email = this.email_form.value.bcc;
    this.bcc_email_list.push(bcc_email);
    this.email_form.get('bcc').reset();
  }

  removeBCCEmail(index) {
    this.bcc_email_list.splice(index, 1);
  }

  // selectFiles(event: any): void {
  //   let files = event.target.files;
  //   // this.upload_files = [];
  //   if (files) {
  //     for (let file of files) {
  //       this.upload_files.push(file);
  //     }
  //   }
  // }

  selectFiles(event: any): void {
    const files = event.target.files;
    if (files) {
      // Calculate current total size of existing files in MB
      const existingTotalSize = this.upload_files.reduce((total, file) =>
        total + file.size / (1024 * 1024), 0);

      let newFilesTotalSize = 0;
      const validFiles: File[] = [];

      // First pass: calculate total size of new files
      for (const file of files) {
        const fileSizeInMB = file.size / (1024 * 1024);
        newFilesTotalSize += fileSizeInMB;

        // Check individual file size
        if (fileSizeInMB > this.maxAttachmentSize) {
          this._toasterService.showWarnig(
            'File size exceeds',
            `File ${file.name} exceeds the size limit of ${this.maxAttachmentSize}MB.`
          );
          continue;
        }
        validFiles.push(file);
      }

      // Check if total size (existing + new) exceeds 25MB
      if (existingTotalSize + newFilesTotalSize > this.maxAttachmentSize) {
        this._toasterService.showWarnig(
          'Total size exceeds limit',
          `Total file size would exceed ${this.maxAttachmentSize}MB limit. Current total: ${existingTotalSize.toFixed(2)}MB, Attempting to add: ${newFilesTotalSize.toFixed(2)}MB`
        );
      } else {
        // Add only valid files if total size is acceptable
        this.upload_files.push(...validFiles);
      }
    }
    // Reset the input value to allow selecting the same file again
    event.target.value = '';
  }

  removeDoc(index: number) {
    this.upload_files.splice(index, 1);
  }

  sendMail() {
    this.is_submitted = true;
    let to_mail = '';
    // if (this.showBankDropdown && this.toDomain) {
    //   const username = this.toUsername.value?.trim();
    //   if (username) {
    //     this.email_form.get('to').setValue(username + this.toDomain);  
    //   } else {
    //      this.email_form.get('to').setValue('');
    //      this._toasterService.showError('ERROR!', 'Username for the recipient is required.');
    //      return;
    //   }
    // }

    if (this.to_email_list.length && this.email_form.value.to) {
          to_mail = this.to_email_list.toString().concat(`,${this.email_form.value.to}`)
        } else if (!this.to_email_list.length && this.email_form.value.to) {
          to_mail = this.email_form.value.to;
        } else if (this.to_email_list.length && !this.email_form.value.to) {
          to_mail = this.to_email_list.toString();
        }
    

    let cc_mail = '';
    if (this.cc_email_list.length && this.email_form.value.cc) {
      cc_mail = this.cc_email_list.toString().concat(`,${this.email_form.value.cc}`)
    } else if (!this.cc_email_list.length && this.email_form.value.cc) {
      cc_mail = this.email_form.value.cc;
    } else if (this.cc_email_list.length && !this.email_form.value.cc) {
      cc_mail = this.cc_email_list.toString();
    }

    let bcc_mail = '';
    if (this.bcc_email_list.length && this.email_form.value.bcc) {
      bcc_mail = this.bcc_email_list.toString().concat(`,${this.email_form.value.bcc}`)
    } else if (!this.bcc_email_list.length && this.email_form.value.bcc) {
      bcc_mail = this.email_form.value.bcc;
    } else if (this.bcc_email_list.length && !this.email_form.value.bcc) {
      bcc_mail = this.bcc_email_list.toString();
    }

    if (to_mail) {
      this.email_form.get('to').clearValidators();
      this.email_form.get('to').updateValueAndValidity();
    }

    if (cc_mail) {
      this.email_form.get('cc').clearValidators();
      this.email_form.get('cc').updateValueAndValidity();
    }

    if (bcc_mail) {
      this.email_form.get('bcc').clearValidators();
      this.email_form.get('bcc').updateValueAndValidity();
    }
    if (this.showBankDropdown) {
      if (to_mail.length === 0 ) {
        this._toasterService.showWarnig('Warnig', 'Please Fill To(Username)')
        return
      }
    } 
    if (this.email_form.invalid) {
      return;
    }
    

    let formData = new FormData();
    // formData.append('from', this.email_form.value.from);
    formData.append('to', to_mail);
    formData.append('cc', cc_mail);
    formData.append('bcc', bcc_mail);
    formData.append('html', this.email_form.value.html);
    formData.append('subject', this.email_form.value.subject);
    formData.append('applicationId', this.cams_id);
    formData.append('showAgent', String(this.email_form.value.agentStatus));


    this.upload_files.forEach(element => {
      formData.append('attachments', element);
    })

    let params = '?';
    if (this.email_form.value.from) {
      params += `from=${this.email_form.value.from}`;
      params += `&applicationId=${this.cams_id}`
    }

    this._loaderService.showLoader();
    this._universitycommunicationService.sendMailv2(params, formData)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res) => {
        this._loaderService.hideLoader();
        if (res?.data?.status) {
          this._toasterService.showSuccess('SUCCESS', 'Email sent successfully');
          this.close(true);
        } else {
          this._toasterService.showError('ERROR!', res?.data?.message);
        }
      }, (err) => {
        this._loaderService.hideLoader();
      })
  }

  close(val?: any) {
    this.dialogRef.close(val);
  }

  ngOnDestroy(): void {
    this.editor.destroy();
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
